import { shallowEqual } from 'react-redux';
import { connectMediaStore, useMMSelector } from './withOwnReduxStore';
import { getFlags } from '@wix/da-react-context/pkg/flags/redux/selectors';

export type WithFeatureFlagsProps = {
  flags: string[];
};

const mapStateToProps = state => ({
  flags: Object.keys(getFlags(state)),
});

export const useFeatureFlags = (): WithFeatureFlagsProps => ({
  ...useMMSelector(mapStateToProps, shallowEqual),
});

export default connectMediaStore(mapStateToProps, {});
